// extracted by mini-css-extract-plugin
export default {"loadingPageWrapper":"loading-page_loadingPageWrapper__5e+eF"};